// extracted by mini-css-extract-plugin
module.exports = {"videoCard":"dashboard_videoCard__3TP-A","videoLoader":"dashboard_videoLoader__3WSHy","videoWrapper":"dashboard_videoWrapper__26ajU","videoFooter":"dashboard_videoFooter__1B2S6"};